import { render, staticRenderFns } from "./login.view.vue?vue&type=template&id=040c2463&scoped=true&"
import script from "./login.view.vue?vue&type=script&lang=ts&"
export * from "./login.view.vue?vue&type=script&lang=ts&"
import style0 from "./login.view.vue?vue&type=style&index=0&id=040c2463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c2463",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VContainer,VForm,VTextField})
